import { ApiError } from "./api";

/** German message for a failed passkey ceremony; the browser's own errors are English and technical. */
export function passkeyErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError) return err.message;
  const name = (err as { name?: string } | null)?.name;
  // Cancelled in the system dialog, timed out, or no passkey for this site on the device.
  if (name === "NotAllowedError" || name === "AbortError") return "Passkey abgebrochen";
  if (name === "InvalidStateError") return "Dieses Gerät hat schon einen Passkey für das Cockpit";
  return fallback;
}
